import i18n from "dynamic/translations/i18n";

/**
 * Returns an array of error messages according to their type.
 * @param {*} message GraphQL error message
 */
export const translateGraphQLErrors = (graphQLErrors) => {
  const errors = (
    (graphQLErrors || [])
      .map(({ message }) => {
        if (typeof message === "string") {
          return message;
        }

        // Custom backend error
        if (message?.errors?.message) {
          return message.errors.message;
        }

        return null;
      })
      .filter((error) => !!error)
  );

  if (!errors.length) {
    errors.push(i18n.t("errors.an_error_occurred_try_again"));
  }

  return errors;
};

/**
 * Translates one GraphQL error according to its type
 */
const translateErrorMessages = ({ networkError, graphQLErrors }) => {
  if (networkError) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.error(networkError);
    }
    return ["Network Error"];
  }

  return translateGraphQLErrors(graphQLErrors);
};

export default translateErrorMessages;
